export const HOME = '/';
export const SETUP = '/setup';
export const SIGNIN = '/signin';
